import { Query } from '@apollo/client/react/components';
import { connect } from 'react-redux';
import React, { Component, Fragment } from 'react';

import Map from './components/Map';
import Navbar from '../../components/Navbar';
import { GET_VERIFICATIONS } from './api';

import { verifyRole } from '../../utils';
import DropdownInput from '../../components/DropdownInput';
import { Loader } from '../../components/Loader';

class VerifiedMap extends Component<any, any> {
  state = {
    year: this.props.year || 2023,
    barCode: '',
    mapView: {
      latitude: -76.4953897,
      longitude: 38.9795382,
      zoom: 13,
    },
    currentBarcode: {
      BarCodeNumber: 0,
      description: '',
    },
  };

  getInventoryYearsAsArray = () => {
    let inventoryYears = [];
    let startYear = 2018;
    let stopYear = new Date().getFullYear();
    while (startYear <= stopYear) {
      inventoryYears.push(startYear);
      startYear++;
    }
    return inventoryYears;
  };

  renderYearButtons = () => {
    return (
      <div className='row'>
        <div className='form-group'>
          {this.getInventoryYearsAsArray().map((year) => {
            return (
              <button
                type='button'
                className={`btn m-2 ${this.state.year === year ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => {
                  this.setState({
                    year: year,
                    barCode: '',
                  });
                }}>
                <i className='fa fa-calendar' />
                <span> {year}</span>
              </button>
            );
          })}
        </div>
      </div>
    );
  };

  onSelect = (currentBarcode: any) => {
    this.setState({
      mapView: {
        latitude: currentBarcode.latitude,
        longitude: currentBarcode.longitude,
        zoom: 20,
      },
      currentBarcode,
    });
  };

  render() {
    let filter = null;

    if (verifyRole(this.props.currentRole.roleName)) {
      //query = getAllVerification(`"${this.state.year}"`, null, null)
      filter = {
        source: 'Non-Capital',
        InventoryYear: `${this.state.year}`,
        hasLocationData: true,
      };
    } else {
      //query = getAllVerification(`"${this.state.year}"`, this.props.currentRole.departmentId, null)
      filter = {
        source: 'Non-Capital',
        InventoryYear: `${this.state.year}`,
        departmentId: this.props.currentRole.departmentId,
        hasLocationData: true,
      };
    }

    return (
      <div>
        <Navbar />
        <div className='container-fluid'>
          <h4 className='p-3'>Verified Map</h4>
          <Query query={GET_VERIFICATIONS} variables={{ filter: filter }}>
            {({ loading, error, data }: any) => {
              if (error) {
                return <h3>We were unable to load your data.</h3>;
              }
              if (loading) return <Loader title={`Loading Items for ${this.state.year}`} />;

              return (
                <Fragment>
                  <h5>{data.readVerificationView.length} scans found with location data</h5>
                  <div className='row'>
                    <div className='col-8 shadow-none p-3 mb-5 bg-light rounded'>
                      <Map
                        mapView={this.state.mapView}
                        data={data.readVerificationView}
                        year={this.state.year}
                        currentBarcode={this.state.currentBarcode}
                      />
                    </div>
                    <div className='col-4 p-3 mb-5'>
                      {this.renderYearButtons()}

                      <div className='row' style={{ paddingLeft: 5, paddingRight: 5 }}>
                        <DropdownInput
                          list={data.readVerificationView}
                          field='BarCodeNumber'
                          placeholder='Search Barcode'
                          value={this.state.barCode}
                          onChange={(barCode) => this.setState({ barCode })}
                          rowItem={(item) => `${item.BarCodeNumber} - ${item.description}`}
                          onSelect={(item) => this.onSelect(item)}
                          filter={(item) => {
                            if ((item.latitude !== null || item.longitude !== null) && (item.latitude !== '0' || item.longitude !== '0')) {
                              if (item.BarCodeNumber.search(new RegExp(this.state.barCode, 'i')) !== -1) {
                                return true;
                              }
                            }

                            return false;
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Fragment>
              );
            }}
          </Query>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  currentRole: state.user.currentRole,
});

export default connect(mapStateToProps)(VerifiedMap);
